import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminPage from "@/pages/AdminPage";
import PlayerPage from "@/pages/PlayerPage";
import SessionMenu from "@/pages/SessionMenu";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SessionMenu />} />
        <Route path="/session/:sessionId" element={<AdminPage />} />
        <Route path="/player" element={<PlayerPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
